/* eslint-disable unicorn/text-encoding-identifier-case */
import { t } from "@lingui/macro";
import { ResumeDto } from "@reactive-resume/dto";
import { HTTPError } from "ky";
import { useState } from "react";

import { getMessage } from "../libs/ajax-utils";
import { ErrorResponse } from "../libs/ajax-utils";
import { kyParent } from "../libs/ky";
import { useOpenAiStore } from "../stores/openai";
import { useToast } from "./use-toast";

export type ChatContent = { role: "user" | "assistant"; content: string };

const useAjaxAiChat = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<string>("");
  const apiKey = useOpenAiStore().apiKey;
  const model = useOpenAiStore().model;

  const { toast } = useToast();

  const doAjax = async (resumeData: ResumeDto, message: ChatContent[]) => {
    setLoading(true);
    let result = "";
    const url = `api/chat`;
    const jsonParam = {
      content: JSON.stringify(resumeData),
      record: message,
      data: resumeData,
      // eslint-disable-next-line lingui/no-unlocalized-strings
      apiKey: apiKey,
      model: model ?? "gpt-4o-mini",
    };
    try {
      const res = await kyParent.post(url, {
        json: jsonParam,
      });

      if (!res.ok) {
        const error = await res.json<ErrorResponse>();
        const message = getMessage(error.error);
        toast({
          title: message ?? t`SecAIChatError`,
          variant: "error",
        });
        return result;
      }
      if (!res.body) {
        return result;
      }
      const reader = res.body.getReader();

      const decoder = new TextDecoder("utf-8");

      const readChunks = async () => {
        const { done, value } = await reader.read();
        if (done) {
          return result;
        }

        // 解码接收到的值并输出
        const chunk = decoder.decode(value, { stream: true });
        result = result + chunk;
        setData(result);
        // 继续读取下一个数据块
        await readChunks();
      };

      await readChunks();
      // result = res.url;
    } catch (error) {
      console.error(error);
      if (error instanceof HTTPError) {
        const json = await error.response.json();
        const message = getMessage(json);
        toast({
          title: message ?? t`SecAIChatError`,
          variant: "error",
        });
      }
    }
    setLoading(false);
    return result;
  };

  return {
    loading,
    doAjax,
    data,
  };
};
export default useAjaxAiChat;
